import React from 'react';
import { Typography, Box, Container, Button, Dialog, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CancelIcon from '@mui/icons-material/Cancel';

const InactiveUser = ({openDialog, azureLogOut}) => {
  const { t } = useTranslation('common');
  return (
    <Dialog
        open={openDialog}
        className="small-dialog dialog-box inactive-user-dialog"
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        >
        <DialogContent className="content-dialog" style={{justifyContent: "flex-start"}}></DialogContent>
            <Container component="main" maxWidth="xs" className="login-conatiner" style={{background: 'transparent'}}>
                <Box
                sx={{  
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
                className="login-card"
                >
                    <CancelIcon style={{fontSize: 75, color: 'red'}} />
                    <Typography component="p" className='mt-20' variant="div" style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, paddingTop: 10, paddingBottom: 30 }}>
                        User is Inactive. Please contact System Admin
                    </Typography>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className="primary-btn mt-20"
                        onClick={()=>{azureLogOut()}}
                        >
                        <span  style={{textTransform: 'capitalize'}}>{t("Logout")}</span>
                        </Button>
                    </Box>
            </Container>
        </Dialog>
  );
}
  
export default (InactiveUser);
